export default __webpack_public_path__ + "static/media/energyAirFlowRightActive.07275494.svg";